import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=0fe2e24b&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=0fe2e24b&prod&lang=scss&scoped=true"
import style1 from "./QuestionDialog.vue?vue&type=style&index=1&id=0fe2e24b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe2e24b",
  null
  
)

export default component.exports